import { render, staticRenderFns } from "./AddEditNews.vue?vue&type=template&id=25bedf42&"
import script from "./AddEditNews.vue?vue&type=script&lang=js&"
export * from "./AddEditNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports